import { useState, useContext, Fragment } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";
import { useSendUpdateEmailOTP } from "../utils/sendUpdateEmailOTP";
import { toast, ToastContainer } from "react-toastify";
import { ReactComponent as BlackVatugIcon } from "../../../Asset/black.svg";
import "react-toastify/dist/ReactToastify.css";
import "./double_check.css";

const DoubleCheck = () => {
  const { userType } = useContext(AuthContext);
  const { mutate: sendOTP } = useSendUpdateEmailOTP();
  const [formData, setFormData] = useState({ oldEmail: "", newEmail: "" });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.oldEmail) formErrors.oldEmail = "Old email is required.";
    if (!formData.newEmail) formErrors.newEmail = "New email is required.";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true); 
      sendOTP(formData, {
        onSuccess: () => {
          toast.success("OTP sent successfully. Please check your email.");
          setIsLoading(false);
        },
        onError: (error) => {
          toast.error(error.message || "Failed to send OTP. Please try again.");
          setIsLoading(false); 
        },
      });
    }
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="signeup-account">
        <div className="content-card">
        <div className="wrap">
        <BlackVatugIcon/>
        <Link to="/Login" >Back</Link>
        </div>
          <form onSubmit={handleSubmit}>
            <h3>Change of email verification</h3>
            <p>For {userType}</p>

            <label>
              <input
                type="email"
                placeholder="Enter old email address"
                name="oldEmail"
                value={formData.oldEmail}
                onChange={handleInputChange}
              />
              {errors.oldEmail && <p className="error">{errors.oldEmail}</p>}
            </label>

            <label>
              <input
                type="email"
                placeholder="Enter new email address"
                name="newEmail"
                value={formData.newEmail}
                onChange={handleInputChange}
              />
              {errors.newEmail && <p className="error">{errors.newEmail}</p>}
            </label>

            <button type="submit" disabled={isLoading}>
              {isLoading ? "Loading..." : "Send OTP"}
            </button>

            <div className="agree">
              <p>
                By continuing, you agree to Vatug's{" "}
                <a href="/">Terms of Service</a> and{" "}
                <a href="/">Privacy Policy</a>.
              </p>
            </div>
          </form>
        </div>
        <div className="img"></div>
      </div>
    </Fragment>
  );
};

export default DoubleCheck;


